import { createReducer } from '@reduxjs/toolkit';
import { PermissionResponse } from 'features/admin-permissions/api/types';
import { adminPermissionsActions } from 'features/admin-permissions/redux/admin-permissions.actions';

const initialState = {
  items: [] as PermissionResponse[],
  loading: false as boolean,
  isLoaded: false as boolean,
  error: {
    permissions: [] as string[],
  },
};

const adminPermissions = createReducer(initialState, (builder) => {
  builder.addCase(adminPermissionsActions.clearState, () => {
    return {
      ...initialState,
    };
  });
  builder.addCase(adminPermissionsActions.getPermissionsRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(
    adminPermissionsActions.getPermissionsSuccess,
    (state, action) => {
      return {
        ...state,
        items: action.payload.items,
        loading: false,
        isLoaded: true,
      };
    }
  );
  builder.addCase(
    adminPermissionsActions.getPermissionsFailure,
    (state, action) => {
      return {
        ...state,
        loading: false,
        isLoaded: false,
        error: { ...state.error, permissions: action.payload },
      };
    }
  );
});

export default adminPermissions;
